export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14956.8bd302e4.jpg";